import { CvDateFormatter, DATEFORMAT } from "@cv-invision/cv.component-library.ux";

export class FILTER_VALUELINK {
	transactionId: string;
	valueLinkOrderId: string;
	eventName: string;
	limit: number;

	constructor(trasactionId = ' ', orderId = ' ', eventName = ' ', limit = 20) {
		this.transactionId = trasactionId;
		this.valueLinkOrderId = orderId;
		this.eventName = eventName;
		this.limit = limit;
	}
};

export class LOG_DETAIL {
	private _columns: Array<any>;

	constructor(private dateService: CvDateFormatter) {
		this._columns = [
            {
                headerName: 'Id',
                field: 'id',
                width: 130
            },
            {
                headerName: 'Transaction',
                field: 'transactionId',
                width: 130
            },
            {
                headerName: 'Class Order ID',
                field: 'orderId',
                width: 90
            },
            {
                headerName: 'Event Name',
                field: 'eventName',
                width: 90
            },
            {
                headerName: 'Value Link Order ID',
                field: 'valueLinkOrderId',
                width: 90
            },
            {
                headerName: 'Value Link Service ID',
                field: 'valueLinkServiceId',
                width: 90
            },
            {
                headerName: 'OrderId',
                field: 'orderId',
                width: 90
            },
            {
                headerName: 'Duration',
                field: 'duration',
                width: 60,
                cellRenderer: 'suffixCellRenderer',
                cellRendererParams: { suffix: 'ms', fieldName: 'duration' }
            },
            {
                headerName: 'Order Response Date',
                field: 'orderResponseDate',
                width: 140,
                valueFormatter: params => dateService.format(DATEFORMAT.YYYY_MM_DD, params.data.orderResponseDate)
            },
            {
                headerName: 'Created (Local)',
                field: 'created',
                width: 160,
                valueFormatter: params => dateService.format(DATEFORMAT.EMPTY, params.data.created)
            }
        ];
    }

	get columns(): Array<any> {
		return this._columns;
	}
}
